<template>
  <div>
    <div
      id="signup-survey"
      :class="{
        'd-none': true,
      }"
    >
      <ClientOnly>
        <div
          id="signup-survey-surveyForm"
          :class="{
            'd-none': true,
          }"
        >
          <div
            id="survey-form"
            :class="{
              'survey-form-message d-none': true,
            }"
            style="padding: 10px 30px 10px 30px; text-align: center"
          >
            Take our survey! Here are is an optional followup question.
          </div>
          <ClientOnly>
            <FormApp
              :form-id="FormIdUtil.names.signupSurvey"
              :class="{
                'formfort-loading formfort-form-container': true,
              }"
              form-variant=""
              ga-action=""
              ga-category=""
              submit-text="Submit Survey"
              redirect-url=""
              hidden-static-field-1=""
              hidden-static-field-2=""
            />
          </ClientOnly>
          <!-- optional success message HTML (clones innerHTML of `form-fort-sucess-message` and deletes this template) -->
          <div
            :form-id="FormIdUtil.names.signupSurvey"
            :class="{
              'formfort-success-message d-none': true,
            }"
            style="display: none"
          >
            &nbsp;
          </div>
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FormIdUtil } from '@onshape/www-inertia';
import FormApp from '~/hekate-www/external/FormApp.vue';
</script>
